module.exports = __webpack_public_path__ + "media/images/flags/hu-afe394d28ed8a3a284e7dadc64c1b8c9.svg";